import React, { Component } from 'react';
import Constants from '../../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../../../common/inputs/select';
import TextBox from '../../../common/inputs/textBox';
import { timers } from 'jquery';

const initialObjectState = {
  direction: "",
  id:  "",
  order:  "",
  type:  ""
}

class InReduceXMetricOrderEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  }

  componentDidMount() {
    this.props.escBehaviourHandler(false);
  }

  componentWillUnmount = () => {
    this.props.escBehaviourHandler(false); 
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {
    let dataPath = this.props["data-path"];
    if(object.type == "" || object.id == "" ||
        (dataPath=="order_by_descriptor" && object.direction == "") ||
        (dataPath=="transformations_descriptor" && object.transformation == "")) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "reportTemplateAdmin.metricDetailColumnsEditor.emptyMetricOrderByError"}),"");
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
    this.props.escBehaviourHandler(false);
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    toAddObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path=="type") {
      toAddObject["id"] = "";
    }
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });   
    this.props.escBehaviourHandler(true); 
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
      this.props.escBehaviourHandler(false);
    }
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({  
      showOverlay: true,    
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
    this.props.escBehaviourHandler(true);
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    toEditObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path=="type") {
      toEditObject["id"] = "";
    }
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
    this.props.escBehaviourHandler(false);
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
      this.props.escBehaviourHandler(false);
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  render() {
    const {
      className,
      typeColumnOptions,
      dimensionColumnOptions,
      valueColumnOptions,
      values,
      titleLabel,
      onChange,
      disabled,
      escBehaviourHandler,
    } = this.props;
    const dataPath = this.props["data-path"];
    let activeKeys = values ? values.map(valueItem => valueItem.type + "_" + valueItem.id) : [];
    let columnOptions = {};
    columnOptions[Constants.selectKeys.reportMetricsDetail.columnTypes.DIMENSION] = dimensionColumnOptions;
    columnOptions[Constants.selectKeys.reportMetricsDetail.columnTypes.VALUE]  = valueColumnOptions;
    let filteredColumnOptions = {};
    filteredColumnOptions[Constants.selectKeys.reportMetricsDetail.columnTypes.DIMENSION] = dimensionColumnOptions ? dimensionColumnOptions.filter(columnItem => !activeKeys.includes(Constants.selectKeys.reportMetricsDetail.columnTypes.DIMENSION + "_" + columnItem.value)) : [];
    filteredColumnOptions[Constants.selectKeys.reportMetricsDetail.columnTypes.VALUE]  = valueColumnOptions ? valueColumnOptions.filter(columnItem => !activeKeys.includes(Constants.selectKeys.reportMetricsDetail.columnTypes.VALUE + "_" + columnItem.value)) : [];
    let blockAdd = (filteredColumnOptions[Constants.selectKeys.reportMetricsDetail.columnTypes.DIMENSION].length > 1 || filteredColumnOptions[Constants.selectKeys.reportMetricsDetail.columnTypes.VALUE].length > 1) ? false : true;
    return (
      <div className={"custom-input free-text-list select-list object-editor metric-detail-other-column-options-editor" + (className ? " " + className : "") + " select-list-no-search" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          {titleLabel}
          {(!disabled && !blockAdd) && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                let finalOptions = this.state.toEditObject.type ? filteredColumnOptions[this.state.toEditObject.type] : [];
                if(this.state.toEditObject.type == item.type) {
                  let optionElement = columnOptions[item.type].find(columnOption => columnOption.value==item.id);
                  let optionElementName = (optionElement ? optionElement.label : item.id);
                  finalOptions = finalOptions.concat([{value: item.id, label: optionElementName}]);
                }
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <Select 
                          className="free-text-list-list-add-item metric-detail-other-column-options-editor-type-input"
                          value={this.state.toEditObject.type}
                          labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.type"/>}
                          options={typeColumnOptions}
                          onChange={this.handleChangeEdit}
                          data-path={"type"}
                        />
                        <Select 
                          className="free-text-list-list-add-item metric-detail-other-column-options-editor-id-input"
                          value={this.state.toEditObject.id}
                          labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.id"/>}
                          options={finalOptions}
                          onChange={this.handleChangeEdit}
                          data-path={"id"}
                        />
                        <Select 
                          className="free-text-list-list-add-item metric-detail-other-column-options-editor-direction-input"
                          value={this.state.toEditObject.direction}
                          labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.direction"/>}
                          options={InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.directionOptions","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.directionOptions")}
                          onChange={this.handleChangeEdit}
                          data-path={"direction"}
                        />
                        <TextBox
                          className="free-text-list-list-edit-item metric-detail-other-column-options-editor-order-input"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeEdit}
                          data-path={"order"}
                          value={this.state.toEditObject.order}
                          onKeyEnter={this.handleOnEnterEditItem}
                          type={Constants.interface.inputs.type.TEXT}
                          dataType={Constants.selectKeys.metric.dataType.NUMBER}
                          labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.order"/>}
                        />
                      </div>
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-objecteditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let nameFinded = columnOptions[item.type].find(column => column.value == item.id);
                nameFinded = (nameFinded ? nameFinded.label : item.id);
                let itemInnerText = intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.columnTypesOptions." + item.type}) + ": " + nameFinded;
                itemInnerText += ("order" in item && item.order!="") ? " (" + item.order + ")" : "";
                itemInnerText += ("direction" in item) ? " -> " + intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.directionOptions." + item.direction}) : "";
                itemInnerText += ("transformation" in item) ? " -> " + intl.formatMessage({id:"reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.transformationOptions." + item.transformation}) : "";
                return (
                  <div key={i} className={"free-text-list-list-item"}>
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-index={i}
                          data-value={JSON.stringify(item)}
                        />
                        <i
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-objecteditor={"true"}
                          data-value={JSON.stringify(item)}
                          data-path={dataPath}
                          onClick={onChange}
                        />
                      </div>
                    )}
                  </div>
                );
              }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add">
              <div className="free-text-list-list-item-inner">
                {(!disabled && !blockAdd) && (
                  <div className="object-editor-inputs">
                    <div className="object-editor-inputs-linebreak">
                      <Select 
                        className="free-text-list-list-add-item metric-detail-other-column-options-editor-type-input"
                        value={this.state.toAddObject.type}
                        labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.type"/>}
                        options={typeColumnOptions}
                        onChange={this.handleChangeAddItem}
                        data-path={"type"}
                        ref={(input) => { this.editItemInput = input; }}
                      />
                      <Select 
                        className="free-text-list-list-add-item metric-detail-other-column-options-editor-id-input"
                        value={this.state.toAddObject.id}
                        labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.id"/>}
                        options={this.state.toAddObject.type ? filteredColumnOptions[this.state.toAddObject.type] : []}
                        onChange={this.handleChangeAddItem}
                        data-path={"id"}
                      />
                      <Select 
                        className="free-text-list-list-add-item metric-detail-other-column-options-editor-direction-input"
                        value={this.state.toAddObject.direction}
                        labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.direction"/>}
                        options={InterfaceTooling.getSelectArray("selectKeys.reportMetricsDetail.directionOptions","reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.directionOptions")}
                        onChange={this.handleChangeAddItem}
                        data-path={"direction"}
                      />                      
                      <TextBox
                        className="free-text-list-list-edit-item metric-detail-other-column-options-editor-order-input"
                        styleType={Constants.interface.inputs.styleType.OUTLINED}
                        onChange={this.handleChangeAddItem}
                        data-path={"order"}
                        value={this.state.toAddObject.order}
                        onKeyEnter={this.handleOnEnterAddItem}
                        type={Constants.interface.inputs.type.TEXT}
                        dataType={Constants.selectKeys.metric.dataType.NUMBER}
                        labelLocale={<FormattedMessage id="reportTemplateAdmin.metricDetailColumnsEditor.metricColumnsLabels.order"/>}
                      />
                    </div>
                  </div>
                )}
              </div>
              {(!disabled && !blockAdd) && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-objecteditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
      </div>
    );
  }
}

export default InReduceXMetricOrderEditor;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/objectInputs/inReduceXMetricOrderEditor.jsx